export default {"src":"https://fishbrain.com/_next/static/media/california.e0d0bb5c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};